export type SelectDataItem = {
  label: string
  value: string
  description: string
  image: string | undefined
  disabled: boolean
}

export const filterOnLabelDescription = (
  search: string,
  options: SelectDataItem[],
) =>
  options.filter((item) => {
    return (
      item.label.toLowerCase().includes(search.toLowerCase().trim()) ||
      item.description.toLowerCase().includes(search.toLowerCase().trim())
    )
  })
